import React, { useContext } from "react";
import { Redirect, Route, useLocation, useHistory } from "react-router-dom";
import Auth from "../contexts/Auth";



const AuthenticatedRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useContext(Auth);


  return (

    <Route
      {...rest}
      render={props => {
        if (isAuthenticated) {
          return <Component {...props} />;
        }
        else {

          return <Redirect to={
            {
              pathname: "/Login",
              state: {
                from: props.location
              }
            }
          } />

        }
      }}
    />
  )


}



export default AuthenticatedRoute;